import {ActionType} from '@typescript/common/actionTypes';
import {WIZARD} from 'constants/actions';

/**
 * Set active wizard tab
 * @param {boolean} sticky - flag enable/disable
 * @returns {ActionType<boolean>} Action
 */
export function toggleSticky(sticky: boolean): ActionType<boolean> {
    return {
        type: WIZARD.TOGGLE_STICKY,
        payload: sticky,
    };
}
